import React from 'react'

function SchoolIcon() {
  return (
    <div style={{ position: 'relative', width: '48px', height: '48px' }}>
      <div
        style={{
          position: 'absolute',
          top: '0',
          left: '0',
          width: '48px',
          height: '48px',
          borderRadius: '50%',
          background: '#C9E9E8',
          zIndex: '1',
        }}
      />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        style={{
          position: 'absolute',
          top: '10px',
          left: '10px',
          zIndex: '2',
        }}
      >
        <path fill="#276865" d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"></path>
      </svg>
    </div>
  )
}

export default SchoolIcon



// WEBPACK FOOTER //
// ./src/components/PlatformSwitch/SchoolIcon.js